/**
 * Normalización de texto para buscadores.
 *
 * Centraliza el criterio de búsqueda del panel: minúsculas, sin acentos y sin
 * espacios sobrantes, de forma que "facturacion" encuentre "Facturación".
 */
export function normalizeSearch(value: unknown): string {
  return String(value ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
}
